import { Injectable } from '@angular/core';
import { IpoTranslatePipe } from '@ip-only/front-end-library';
import { SpanProperties } from '../../../../span-progress-app/span-progress-entities';
import {
  calculateAndFormatSpanLengthFromSpanProperties,
  formatSpanLength,
} from '../../../../span-progress-app/utils/span-length.helper';
import { getFormattedYearMonthDate } from '../../../util/date-helper';
import { RolloutProgressReportEntities } from '../entities';
import {
  getUniqueAccommodationMethodsFromSpanProperties,
  getUniqueAccommodationTypesFromSpanProperties,
} from '../helper/construction-definition-helper';

@Injectable({
  providedIn: 'root',
})
export class ReportInfoService {
  constructor(private readonly translate: IpoTranslatePipe) {}

  createReportInfoDataForMultiSpan = (
    reportData: RolloutProgressReportEntities.v3.ReportResponse,
    spanPropertiesArray: SpanProperties[],
  ): RolloutProgressReportEntities.v3.ReportInfoData => {
    const spanSerialNumbers = spanPropertiesArray.map(
      (spanProperties) => spanProperties.serialNumber,
    );

    const uniqueMethods =
      getUniqueAccommodationMethodsFromSpanProperties(spanPropertiesArray);

    const uniqueTypes =
      getUniqueAccommodationTypesFromSpanProperties(spanPropertiesArray);

    const totalLength =
      calculateAndFormatSpanLengthFromSpanProperties(spanPropertiesArray);

    return this.createReportInfoData(reportData, spanSerialNumbers, true, [
      [
        this.createReportInfoItem('reportInfo.method', uniqueMethods),
        this.createReportInfoItem('reportInfo.spanType', uniqueTypes),
        this.createReportInfoItem('reportInfo.length', [
          this.formatSpanLengthString(totalLength),
        ]),
      ],
    ]);
  };

  /*
  This can later be split into more functions.
  Each point can have it's own funtion if needed
  (as done for span vs point)

  createReportInfoDataForSite, createReportInfoDataForHub etc.
  */
  createReportInfoDataForPoint(
    reportData: RolloutProgressReportEntities.v3.ReportResponse,
    reference: string,
  ): RolloutProgressReportEntities.v3.ReportInfoData {
    return this.createReportInfoData(reportData, [reference], false);
  }

  createReportInfoItem(
    label: string,
    values: string[],
  ): RolloutProgressReportEntities.v3.ReportInfoItem {
    return { label, values };
  }

  private createReportInfoData(
    reportData: RolloutProgressReportEntities.v3.ReportResponse,
    reference: string[],
    showDeviationPill: boolean,
    groups: RolloutProgressReportEntities.v3.ReportInfoGroup[] = [],
  ): RolloutProgressReportEntities.v3.ReportInfoData {
    return {
      lastUpdatedBy: this.formatLastUpdatedBy(
        reportData.lastUpdateAt,
        reportData.updatedBy,
      ),
      referenceField: this.createReportInfoItem(
        'reportInfo.referenceLabel.' + reportData.type,
        reference,
      ),
      type: reportData.type,
      status: reportData.status,
      showDeviationPill,
      isDeviation: reportData.isDeviated,
      groups,
    };
  }

  private formatLastUpdatedBy(
    lastUpdateAt: Date | undefined,
    updatedBy: string,
  ): string {
    if (lastUpdateAt && updatedBy) {
      return `${getFormattedYearMonthDate(lastUpdateAt.toString())} ${updatedBy}`;
    } else {
      return '-';
    }
  }

  private formatSpanLengthString(length: string): string {
    return `${formatSpanLength(length)} ${this.translate.transform('reportInfo.meters')}`;
  }
}
